// src/features/login/LoginSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ENDPOINT, Urls } from '../../../network/config';

// Async thunk for login
export const loginUser = createAsyncThunk(
  'login/loginUser',
  async ({ email, password }, thunkAPI) => {
    try {
      const response = await fetch(`${ENDPOINT}/${Urls.login}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Use real auth header or remove it if not required:
          // "Authorization": "Bearer YOUR_SECRET" 
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (data.responseStatus === 1) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data?.message || "Login failed");
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const loginSlice = createSlice({
  name: 'login',
  initialState: {
    isLoading: false,
    user: null,
    error: null,
  },
  reducers: {
    logout: (state) => {
      localStorage.clear();
      state.user = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload?.Data?.user || null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export const { logout } = loginSlice.actions;
export default loginSlice.reducer;
